
import React, { useCallback } from 'react';
import './App.css';
import Colors from './Colors';
import Rims from './Rims';
import { bodyColors, rimStyles, rimColors, fenders, roofs, engines, roofColors } from './data/config';
import Fenders from './Fenders';
import Model from './Model';
import Roof from './Roof';
import Engine from './Engine';
import imageList90 from './data/image_list_90.json';
import imageList110 from './data/image_list_110.json';
import mobileImageList90 from './data/mobile_image_list_90.json';
import mobileImageList110 from './data/mobile_image_list_110.json';


function App() {
  const [view, updateView] = React.useState('Front');
  const [model, updateModel] = React.useState(90);
  const [color, updateColor] = React.useState(bodyColors[0]);
  const [rimStyle, updateRimStyle] = React.useState(rimStyles[0]);
  const [rimColor, updateRimColor] = React.useState(rimColors["body-color"]);
  const [roof, updateRoof] = React.useState(roofs[0]);
  const [roofColor, updateRoofColor] = React.useState(roofColors.find(c => c.id === roofs[0].colors[0]));
  const [fender, updateFender] = React.useState(fenders[0]);
  const [engine, updateEngine] = React.useState(engines[0]);
  const [loadedImages, setLoadedImages] = React.useState({});
  const [loadingImages, setLoadingImages] = React.useState(true);
  const [isMobile, setIsMobile] = React.useState(['','']);
  const [firstLoad, setFirstLoad] = React.useState(true);
  // const [name, setName] = React.useState('');
  // const [email, setEmail] = React.useState('');
  // const [nameError, setNameError] = React.useState('');
  // const [emailError, setEmailError] = React.useState('');

  const batchLoadImages = useCallback((list) => {
    const batchSize = 400;
    const totalBatches = Math.ceil(list.length / batchSize);
    let images = {};
    let batchPromises = [];

    for (let i = 0; i < totalBatches; i++) {
      const batchStartIndex = i * batchSize;
      const batchEndIndex = (i + 1) * batchSize;
      const batch = list.slice(batchStartIndex, batchEndIndex);

      const batchPromise = Promise.all(
        batch.map((imageSrc, index) => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
              images[imageSrc] = img;
              resolve();
            };
            img.onerror = () => {
              reject(new Error(`Failed to load image: ${imageSrc}`));
            };
            img.src = imageSrc;
          });
        })
      );

      // batchPromises.push(batchPromise);
      batchPromise.then(() => {
        if(firstLoad){
          setLoadingImages(false);
        }
        setFirstLoad(false);
        setLoadedImages(state => {
          return {...state, ...images};
        });
      }).catch((error) => {
        console.error(error);
      });
    }

    Promise.all(batchPromises)
      .then(() => {
        setLoadedImages(images);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  [firstLoad]);

  React.useEffect(() => {
    if (window.innerWidth <= 768) {
      setIsMobile(['Mobile/','_Mobile']);
      batchLoadImages(mobileImageList90);
      batchLoadImages(mobileImageList110);
    } else {
      batchLoadImages(imageList90);
      batchLoadImages(imageList110);
    }
  }, [batchLoadImages]);

  const handleRotateView = () => {
    updateView(view === 'Front' ? 'Rear' : 'Front');
  }

  // const handleNameChange = (e) => {
  //   setName(e.target.value);
  //   setNameError('');
  // };

  // const handleEmailChange = (e) => {
  //   setEmail(e.target.value);
  //   setEmailError('');
  // };

  // const isValidEmail = (email) => {
  //   return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  // };

  // const handleSubmition = () => {



  //   // if (!name) {
  //   //   setNameError('Name is required');
  //   // }

  //   // if (!email) {
  //   //   setEmailError('Email is required');
  //   // } else if (!isValidEmail(email)) {
  //   //   setEmailError('Invalid email');
  //   // }

    

  //   // let message = `You have selected the following options:\n\n
  //   // Model: ${model === 90 ? '90' : '110'}\n
  //   // Engine: ${engine.name}\n
  //   // Color: ${color.name}\n
  //   // Roof: ${roof.name}\n
  //   // Roof Color: ${roofColor.id === 'body-color' ? color.name : roofColor.name}\n
  //   // Rim Style: ${rimStyle.name}\n
  //   // Rim Color: ${rimColor.id === 'body-color' ? color.name : rimColor.name}\n
  //   // Fender: ${fender.id === 'body-color' ? color.name : fender.name}\n
  //   // `;

  //   // alert(message);

  //   // Clear form
  //   setName('');
  //   setEmail('');
  //   setNameError('');
  //   setEmailError('');
  // }

  return (
    <div className='grid grid-cols-12'>
      <div className='col-span-12 lg:col-span-8 lg:relative lg:flex lg:justify-center fixed bg-[#cecfcf] w-full'>
        <div className='absolute top-4 right-4 md:top-6 md:right-8 hover:bg-tan-300 cursor-pointer rounded text-white duration-300 p-3 z-50 flex flex-col items-center justify-center' onClick={handleRotateView}>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-repeat h-8 w-8 md:w-12 md:h-12" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" stroke="#252525"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3" /><path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3" /></svg>
          <p className='text-black items-center justify-center hidden md:flex'>Flip View</p>
        </div>
        <div className='flex items-center h-full w-full'>
          <div className=' lg:aspect-[5/4] md:aspect-video aspect-[12/10] relative w-full'>
            {
              loadingImages &&
              <div className='absolute top-0 left-0 w-full h-full flex items-center justify-center flex-col gap-4'>
                <img src="/images/loading.gif" alt="loading icon defender" className='md:w-64 w-32' />
                <p className='md:text-3xl text-lg text-black'>Loading your next adventure...</p>
              </div>
            }
            {!loadingImages &&
              <>
                <div className='w-full absolute bottom-0 h-20 bg-gradient-to-t from-[#cecfcf] to-white/0' />
                <div className='w-full absolute top-o h-20 bg-gradient-to-b from-[#cecfcf] to-white/0' />

                {/* Chassis */}
                <img loading='lazy' className='object-cover w-full h-full absolute top-0 left-0' src={loadedImages[`./images/${isMobile[0]}Defender ${model}/${view}/TATC_Config_D${model}_${view}_View_Chassis${isMobile[1]}.png`]?.src} alt="chassis" />
                {/* Body */}
                <img loading='lazy' className='object-cover w-full h-full absolute top-0 left-0' src={loadedImages[`./images/${isMobile[0]}Defender ${model}/${view}/TATC_Config_D${model}_${view}_View_Body_${model === 110 ? 'Hardtop' : roof.prefix}_${color.prefix}${isMobile[1]}.png`]?.src} alt="body" />
                {/* Roof */}
                {(roofColor.id !== 'body-color' && roof.id !== 'softtop') &&
                  <img loading='lazy' className='object-cover w-full h-full absolute top-0 left-0' src={loadedImages[`./images/${isMobile[0]}Defender ${model}/${view}/TATC_Config_D${model}_${view}_View_Body_${roof.prefix}_Roof_${roofColor.prefix}${isMobile[1]}.png`]?.src} alt="roof" />
                }
                {/* Background */}
                <img loading='lazy' className='object-cover w-full h-full' src={loadedImages[`./images/${isMobile[0]}Defender ${model}/${view}/TATC_Config_D${model}_${view}_View_Background${isMobile[1]}.png`]?.src} alt="background" />
                {/* Rims */}
                <img className='object-cover w-full h-full absolute top-0 left-0' src={loadedImages[`./images/${isMobile[0]}Defender ${model}/${view}/TATC_Config_D${model}_${view}_View_Rims_${rimStyle.prefix}_${rimColor.id === 'body-color' ? color.prefix : rimColor.prefix}${isMobile[1]}.png`]?.src} alt="rims" />
                {/* Fender */}
                {fender.id !== 'body-color' &&
                  <img className='object-cover w-full h-full absolute top-0 left-0' src={loadedImages[`./images/${isMobile[0]}Defender ${model}/${view}/TATC_Config_D${model}_${view}_View_Fender_${fender.prefix}${isMobile[1]}.png`]?.src} alt="fender" />
                }
              </>
            }
          </div>
        </div>
      </div>
      <div className='col-span-12 lg:col-span-4 p-6 pb-32 space-y-12 lg:overflow-scroll h-auto lg:h-screen lg:pt-0 md:pt-[56.25vw] pt-[85vw]'>
        <h2 className='text-3xl text-center mt-8'>Defender Configurator</h2>
        <Model
          selectedModel={model}
          selectModel={updateModel}
        />
        <Roof
          selectedRoof={roof}
          selectRoof={updateRoof}
          selectedRoofColor={roofColor}
          selectRoofColor={updateRoofColor}
          model={model}
        />
        <Colors
          selectedColor={color}
          setSelectedColor={updateColor}
        />
        <Rims
          selectedRimStyle={rimStyle}
          selectRimStyle={updateRimStyle}
          selectedRimColor={rimColor}
          selectRimColor={updateRimColor}
          selectedColor={color}
        />
        <Fenders
          selectedFender={fender}
          selectFender={updateFender}
        />
        <Engine
          selectedEngine={engine}
          selectEngine={updateEngine}
        />
        {/* <div>
          <h2 className='section-title'>Contact Information</h2>
          <div className='flex flex-col text-center'>
            <label className='subsection-title' htmlFor="name">Name:</label>
            <input
              placeholder='Please enter your name'
              type="text"
              id="name"
              value={name}
              onChange={handleNameChange}
              className={`mb-2 border px-4 py-2 rounded-md text-center ${nameError ? 'border-rose-500' : 'border-gray-200'}`}
            />
            {nameError && <p className='mb-4 text-rose-500'>{nameError}</p>}
            <label className='subsection-title' htmlFor="email">Email:</label>
            <input
              placeholder='Please enter your email'
              type="email"
              id="email"
              value={email}
              onChange={handleEmailChange}
              className={`mb-2 border px-4 py-2 rounded-md text-center ${emailError ? 'border-rose-500' : 'border-gray-200'}`}
            />
            {emailError && <p className='mb-4 text-rose-500'>{emailError}</p>}
          </div>
        </div> */}
        <button
          className='appearance-none w-full flex text-2xl text-white font-bold items-center justify-center py-3 px-3 rounded-md bg-tan uppercase bg-navy-950 hover:bg-navy-900 duration-300'
          onClick={() => window.open('https://www.landroverdefenderusa.com/contact/', '_parent')}
        >
          Contact Us
        </button>
      </div>
    </div>
  );
}

export default App;
